import { IItemCache } from '../IItemCacheObserver';
import { itemsScopeHostControl } from '../../controls/itemsScopeHostControl';

/**
 * Within an Item Cache selector, gets information about the closest `ItemsScope` to the current component.
 * @public
 */
export function getItemsScope(itemCache: IItemCache, props: {} = {}): {
  itemsScopeItemKey?: string;
} {
  const controlHandler = itemCache.demandItemFacet(itemsScopeHostControl, undefined);

  return itemsScopeHostControl.evaluate(controlHandler)(itemCache, {});
}
